module.exports = __webpack_public_path__ + "logo-black.b8e4d90e593546b84b04db92c21e26a5.svg";